import { useRegisterSW } from "virtual:pwa-register/react";

/** Bottom toast: prompts to reload when a new SW is waiting, and a one-time
 *  "ready to work offline" confirmation. Registers the service worker. */
export function PwaUpdater() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!offlineReady && !needRefresh) return null;

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  return (
    <div
      role="status"
      style={{
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: "calc(156px + env(safe-area-inset-bottom))",
        zIndex: 60,
        display: "flex",
        alignItems: "center",
        gap: 12,
        maxWidth: "calc(100vw - 24px)",
        padding: "10px 14px",
        borderRadius: 12,
        background: "var(--ink)",
        color: "var(--canvas)",
        boxShadow: "var(--shadow-md)",
        fontSize: 14,
      }}
    >
      <span>{needRefresh ? "New version available" : "Ready to work offline"}</span>
      {needRefresh && (
        <button
          type="button"
          onClick={() => void updateServiceWorker(true)}
          style={{
            background: "var(--canvas)",
            color: "var(--ink)",
            border: "none",
            borderRadius: 8,
            padding: "6px 12px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Reload
        </button>
      )}
      <button
        type="button"
        onClick={close}
        aria-label="Dismiss"
        style={{ background: "transparent", border: "none", color: "var(--canvas)", cursor: "pointer", fontSize: 16 }}
      >
        ✕
      </button>
    </div>
  );
}
